/* Reels (home) — tema Allure TecDoc.
   Portado de product-reels.js (tema staging): loop infinito con clones, autoplay mudo al entrar en
   pantalla, modal con sonido al hacer clic. Selectores con prefijo al- para no chocar con el SPA. */
(() => {
  const init = () => {
    // ── Modal ────────────────────────────────────────────────────────────────
    const modal = document.querySelector('[data-reel-modal]');
    const modalVideo = modal && modal.querySelector('[data-reel-modal-video]');
    const modalClose = modal && modal.querySelector('[data-reel-close]');
    const supportsDialog = !!modal && typeof modal.showModal === 'function';

    const openModal = (videoEl) => {
      if (!modal || !modalVideo || !videoEl) return;
      modalVideo.innerHTML = '';
      videoEl.querySelectorAll('source').forEach((src) => {
        const s = document.createElement('source');
        s.src = src.src || src.dataset.src || '';
        s.type = src.type;
        modalVideo.appendChild(s);
      });
      modalVideo.load();
      if (supportsDialog) modal.showModal(); else modal.setAttribute('open', '');
      modalVideo.muted = false;
      modalVideo.play().catch(() => {});
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      if (!modal || !modalVideo) return;
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.innerHTML = '';
      if (supportsDialog && modal.open) modal.close(); else modal.removeAttribute('open');
      document.body.style.overflow = '';
    };

    if (modal && !modal.dataset.bound) {
      modal.dataset.bound = '1';
      modalClose && modalClose.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
      modal.addEventListener('cancel', (e) => { e.preventDefault(); closeModal(); });
    }

    // ── Lazy-load de fuentes (data-src → src) ────────────────────────────────
    const loadVideo = (video) => {
      if (!video || video.dataset.loaded) return;
      video.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); });
      if (video.readyState === 0) video.load();
      video.dataset.loaded = '1';
    };
    const prewarmPoster = (videoEl) => {
      const p = videoEl && videoEl.getAttribute('poster');
      if (p) { const img = new Image(); img.src = p; }
    };

    // ── Por sección ──────────────────────────────────────────────────────────
    document.querySelectorAll('.al-sec-reels').forEach((section) => {
      if (section.dataset.reelsReady) return;
      const track = section.querySelector('[data-reels-track]');
      const prevBtn = section.querySelector('[data-reels-prev]');
      const nextBtn = section.querySelector('[data-reels-next]');
      if (!track) return;
      const realCards = [...track.querySelectorAll('[data-reel-card]')];
      if (!realCards.length) return;
      section.dataset.reelsReady = '1';

      realCards.forEach((card) => {
        const video = card.querySelector('[data-reel-video]');
        const btn = card.querySelector('[data-reel-open]');
        btn && btn.addEventListener('click', () => openModal(video));
      });

      // Loop infinito: clones en ambos extremos
      const CLONE_N = Math.min(4, realCards.length);
      const makeClone = (card) => {
        const c = card.cloneNode(true);
        c.removeAttribute('data-reel-card');
        c.setAttribute('aria-hidden', 'true');
        c.classList.add('al-reel-clone');
        // Los clones también cargan su video: sin poster, un clon sin fuente se ve negro en el borde.
        const cv = c.querySelector('[data-reel-video]');
        prewarmPoster(cv); loadVideo(cv);
        return c;
      };
      for (let i = realCards.length - CLONE_N; i < realCards.length; i++) track.insertBefore(makeClone(realCards[i]), track.firstChild);
      for (let i = 0; i < CLONE_N; i++) track.appendChild(makeClone(realCards[i]));
      prewarmPoster(realCards[0].querySelector('[data-reel-video]'));
      prewarmPoster(realCards[realCards.length - 1].querySelector('[data-reel-video]'));

      const getStride = () => {
        const card = track.querySelector('[data-reel-card]');
        if (!card) return 0;
        return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12);
      };

      const teleport = (delta) => {
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
        track.scrollLeft += delta;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          track.style.scrollSnapType = '';
          track.style.scrollBehavior = '';
        }));
      };

      // Posición inicial: saltar los clones del inicio para mostrar el video real #1.
      // La sección puede estar display:none al cargar (la vista la prende después): reintenta.
      const initScroll = (attempt = 0) => {
        const s = getStride();
        if (!s && attempt < 60) { setTimeout(() => initScroll(attempt + 1), 100); return; }
        if (!s) return;
        teleport(CLONE_N * s - track.scrollLeft);
      };
      requestAnimationFrame(() => initScroll());

      let jumping = false;
      const unlockJump = () => {
        const t = setTimeout(() => { jumping = false; }, 250);
        if ('onscrollend' in track) {
          track.addEventListener('scrollend', () => { clearTimeout(t); jumping = false; }, { once: true, passive: true });
        }
      };

      track.addEventListener('scroll', () => {
        if (jumping) return;
        const s = getStride();
        if (!s) return;
        const realSpan = realCards.length * s;
        const leftBound = CLONE_N * s;
        const rightBound = leftBound + realSpan;
        const BUFFER = s * 1.5;
        if (track.scrollLeft < leftBound - BUFFER) { jumping = true; teleport(realSpan); unlockJump(); }
        else if (track.scrollLeft >= rightBound - BUFFER) { jumping = true; teleport(-realSpan); unlockJump(); }
      }, { passive: true });

      // Autoplay mudo + lazy-load al entrar en pantalla
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const v = entry.target.querySelector('[data-reel-video]');
            if (!v) return;
            if (entry.isIntersecting) { loadVideo(v); if (entry.intersectionRatio > 0.55) v.play().catch(() => {}); }
            else v.pause();
          });
        }, { threshold: [0, 0.55, 1] });
        // Observa reales y clones: así los clones visibles en el borde también reproducen.
        track.querySelectorAll('.al-reel').forEach((card) => io.observe(card));
      }

      if (prevBtn && nextBtn) {
        prevBtn.hidden = false; nextBtn.hidden = false;
        const scrollBy1 = (dir) => { const s = getStride(); if (s) track.scrollBy({ left: dir * s, behavior: 'smooth' }); };
        prevBtn.addEventListener('click', () => scrollBy1(-1));
        nextBtn.addEventListener('click', () => scrollBy1(1));
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // El editor de temas re-renderiza la sección al editarla: volver a inicializar.
  document.addEventListener('shopify:section:load', init);
})();
